import type { ModuleDefinition } from '../../../../app/moduleRegistry';

/** CMS İçerik: Destinasyonlar (Destination) — Master-GSA-only, gated behind `HasCmsB2C`. No
 *  longer a standalone routed page: `DestinationListPage` now requires a `siteId` prop and is
 *  rendered directly as a tab inside `SiteDetailPage` (see
 *  ../../site/site/pages/SiteDetailPage.tsx), so this sub-module contributes no route/menu
 *  item of its own — kept only so the sibling `cms/content` aggregator's import shape stays
 *  uniform. Its child resource `DestinationDetail` has no list route at all and stays nested
 *  CRUD inside the list page's edit dialog (see ./components/DestinationDetailsSection.tsx). */
export const destinationModule: ModuleDefinition = {
  routes: [],
  menuItems: [],
};
